import { stdObject } from "../../../data/types/stdObject";

export const selectUsersList = (key: number | string, params: stdObject) => {
  const { helperList, tecnicList, sellerList } = params;
  switch (key) {
    case 1:
      return helperList;
    case 2:
      return tecnicList;
    case 3:
      return sellerList;
    default:
      return sellerList;
  }
};
